import BaseEntity from '../../base/BaseEntity.model';

export default class TramiteTransaccionNoAutorizadaModel extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public comentario?: string;
    constructor(public transaccionId: number | undefined = undefined) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.comentario = undefined;
    }
}
export class TransaccionNoAutorizadaModel {
    public descripcion: string;
    public telefono: string;
    public transacciones: TramiteTransaccionNoAutorizadaModel[];
    constructor() {
        this.descripcion = '';
        this.telefono = '';
        this.transacciones = [];
    }
}
